export class Feedback {
  constructor(success, message) {
    this.success = success;
    this.message = message;
  }
}